// extracted by mini-css-extract-plugin
export var animating = "_2o-3";
export var background = "_2o-6";
export var constrainHeight = "_2o-2";
export var dark = "_2o-4";
export var dropdown = "_2o-1";
export var leave = "_2o-5";
export var option = "_2o-7";
export var root = "_2o-0";